var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oct-dialog ss-dialog",class:[
    { 'oct-dialog--full': _vm.full },
    `oct-dialog--${_vm.align}`
  ]},[_c('div',{staticClass:"oct-dialog__container ss-dialog__container"},[_c('div',{staticClass:"oct-dialog__surface",attrs:{"role":"alertdialog","aria-modal":"true"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{key:_vm.$route.name,staticClass:"ss-dialog__content"})],1)],1)]),_c('div',{staticClass:"oct-dialog__scrim",on:{"click":function($event){return _vm.$emit('dismiss')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }